import { render, staticRenderFns } from "./ComponentTab.vue?vue&type=template&id=0eb7b8f9&"
import script from "./ComponentTab.vue?vue&type=script&lang=js&"
export * from "./ComponentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports